import React, { useState } from 'react';
import { Drawer, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import NestedList from './MenuAccordion'; 
import './Header.scss';

export default function CustomizedMenus() {
  const [open, setOpen] = useState(false); 

  const handleToggle = (state) => () => {
    setOpen(state);
  };

  return (
    <div className="mobile-menu-wrap">
      <IconButton onClick={handleToggle(true)} className="menu-btn">
        <MenuIcon />
      </IconButton>
      <Drawer anchor="left" open={open} onClose={handleToggle(false)}>
        <div style={{display:'flex',flexDirection:'column'}}>
          <IconButton onClick={handleToggle(false)} style={{ margin: '10px' }}>
            <CloseIcon className='closeicon' />
          </IconButton>
          <NestedList />
        </div>
      </Drawer>
    </div>
  );
}
